import React from "react";
import { useFormContext } from "react-hook-form";

const Checkbox = ({
  name,
  label,
  description,
  infoTooltip,
  className = "",
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={`sm:col-span-3 ${className}`}>
      <div className="flex items-start">
        <input
          type="checkbox"
          id={name}
          {...register(name)}
          className="focus:ring-brand-primary h-4 w-4 text-indigo-600 border-gray-300 rounded mt-1"
        />
        <div className="ml-3">
          <div className="flex items-center">
            <label
              htmlFor={name}
              className="block text-sm font-medium mb-1 text-gray-600 dark:text-gray-300"
            >
              {label}
            </label>
            {infoTooltip && <div className="ml-1">{infoTooltip}</div>}
          </div>
          {description && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{description}</p>
          )}
        </div>
      </div>
      {errors[name] && (
        <p className="mt-2 text-sm text-danger">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export { Checkbox };
